(function () {
	const initFaqSystem = (root) => {
		const scopes = root
			? [root]
			: Array.from(document.querySelectorAll("[data-faq-system]"));

		scopes.forEach((section) => {
			if (section.dataset.faqInit === "1") return;
			section.dataset.faqInit = "1";

			const perPage = parseInt(section.dataset.questionsPerPage, 10) || 5;

			// --- Accordion (reuse collapsible-content pattern, scoped) ---
			section
				.querySelectorAll(".collapsible-content__toggle")
				.forEach((toggle) => {
					toggle.addEventListener("click", () => {
						const item = toggle.parentElement;
						const answer = toggle.nextElementSibling;
						if (!item || !answer) return;

						const itemsWrap = toggle.closest(".collapsible-content__items");
						if (!item.classList.contains("active")) {
							if (itemsWrap) {
								itemsWrap
									.querySelectorAll(".collapsible-content__item.active")
									.forEach((other) => {
										if (other === item) return;
										other.classList.remove("active");
										const otherAnswer = other.querySelector(
											".collapsible-content__answer"
										);
										if (otherAnswer && window.jQuery) {
											window.jQuery(otherAnswer).stop().slideUp(300);
										} else if (otherAnswer) {
											otherAnswer.style.display = "none";
										}
									});
							}
							item.classList.add("active");
							if (window.jQuery) {
								window.jQuery(answer).stop().slideDown(300);
							} else {
								answer.style.display = "block";
							}
						} else {
							item.classList.remove("active");
							if (window.jQuery) {
								window.jQuery(answer).stop().slideUp(300);
							} else {
								answer.style.display = "none";
							}
						}
					});
				});

			// --- Tabs ---
			const tabs = section.querySelectorAll("[data-faq-tab]");
			const panels = section.querySelectorAll("[data-faq-panel]");

			tabs.forEach((tab) => {
				tab.addEventListener("click", () => {
					const idx = tab.getAttribute("data-faq-tab");
					tabs.forEach((t) => {
						const active = t === tab;
						t.classList.toggle("is-active", active);
						t.setAttribute("aria-selected", active ? "true" : "false");
					});
					panels.forEach((panel, pIdx) => {
						const active = String(pIdx) === idx;
						panel.classList.toggle("is-active", active);
						if (active) {
							panel.removeAttribute("hidden");
						} else {
							panel.setAttribute("hidden", "");
						}
					});
				});
			});

			// --- Search ---
			const searchInput = section.querySelector("[data-faq-search]");
			const clearBtn = section.querySelector("[data-faq-search-clear]");
			if (searchInput) {
				const resetItems = () => {
					section.classList.remove("faq-system--searching");
					tabs.forEach((t) => {
						t.classList.remove("has-matches", "no-matches");
						delete t.dataset.matchCount;
					});
					panels.forEach((panel) => {
						panel
							.querySelectorAll("[data-faq-item]")
							.forEach((item, i) => {
								item.classList.remove("faq-system__item--match");
								item.classList.toggle(
									"faq-system__item--hidden",
									i >= perPage
								);
							});
						const empty = panel.querySelector("[data-faq-panel-empty]");
						if (empty) empty.hidden = true;
					});
					section
						.querySelectorAll("[data-faq-load-more]")
						.forEach((btn) => {
							btn.classList.remove("is-expanded");
							btn.style.display = "";
							const labelEl = btn.querySelector(
								"[data-faq-load-more-label]"
							);
							if (labelEl) {
								labelEl.textContent = btn.dataset.moreLabel || labelEl.textContent;
							}
						});
					if (clearBtn) clearBtn.hidden = true;
				};

				const runSearch = (raw) => {
					const term = raw.trim().toLowerCase();
					if (clearBtn) clearBtn.hidden = term === "";

					if (term === "") {
						resetItems();
						return;
					}

					section.classList.add("faq-system--searching");
					const counts = [];
					let firstMatchIdx = -1;

					panels.forEach((panel, pIdx) => {
						let matches = 0;
						panel
							.querySelectorAll("[data-faq-item]")
							.forEach((item) => {
								const q =
									(
										item.querySelector(".collapsible-content__question")
											?.textContent || ""
									).toLowerCase();
								const a =
									(
										item.querySelector(".collapsible-content__answer-inner")
											?.textContent || ""
									).toLowerCase();
								const hit = q.includes(term) || a.includes(term);
								item.classList.toggle("faq-system__item--match", hit);
								item.classList.toggle("faq-system__item--hidden", !hit);
								if (hit) matches++;
							});
						counts.push(matches);
						if (matches > 0 && firstMatchIdx === -1) firstMatchIdx = pIdx;

						// Per-panel empty state
						const empty = panel.querySelector("[data-faq-panel-empty]");
						if (empty) {
							const qSpan = empty.querySelector("[data-faq-query]");
							if (qSpan) qSpan.textContent = raw.trim();
							empty.hidden = matches > 0;
						}

						// Toggle dataset so the panel is flagged
						panel.dataset.matchCount = matches;
					});

					tabs.forEach((tab, idx) => {
						const c = counts[idx] || 0;
						tab.dataset.matchCount = c;
						tab.classList.toggle("has-matches", c > 0);
						tab.classList.toggle("no-matches", c === 0);
					});

					if (firstMatchIdx !== -1 && tabs.length > 0) {
						const activeTab = section.querySelector(
							"[data-faq-tab].is-active"
						);
						const activeIdx = activeTab
							? parseInt(activeTab.dataset.faqTab, 10)
							: 0;
						if ((counts[activeIdx] || 0) === 0) {
							const target = section.querySelector(
								`[data-faq-tab="${firstMatchIdx}"]`
							);
							if (target) target.click();
						}
					}
				};

				let debounce;
				searchInput.addEventListener("input", () => {
					clearTimeout(debounce);
					debounce = setTimeout(() => runSearch(searchInput.value), 80);
				});

				if (clearBtn) {
					clearBtn.addEventListener("click", () => {
						searchInput.value = "";
						resetItems();
						searchInput.focus();
					});
				}

				section
					.querySelectorAll("[data-faq-reset]")
					.forEach((btn) => {
						btn.addEventListener("click", () => {
							searchInput.value = "";
							resetItems();
							searchInput.focus();
						});
					});
			}

			// --- Load more (per panel) ---
			section
				.querySelectorAll("[data-faq-load-more]")
				.forEach((btn) => {
					const panel = btn.closest("[data-faq-panel]");
					if (!panel) return;
					const labelEl = btn.querySelector("[data-faq-load-more-label]");
					const moreLabel = btn.dataset.moreLabel || (labelEl ? labelEl.textContent : "Load more");
					const lessLabel = btn.dataset.lessLabel || "Show less";

					btn.addEventListener("click", () => {
						const hidden = panel.querySelectorAll(".faq-system__item--hidden");
						const expanded = btn.classList.contains("is-expanded");

						if (expanded) {
							// Collapse back to perPage
							panel
								.querySelectorAll("[data-faq-item]")
								.forEach((item, i) => {
									item.classList.toggle(
										"faq-system__item--hidden",
										i >= perPage
									);
									if (i >= perPage) {
										item.classList.remove("active");
										const ans = item.querySelector(".collapsible-content__answer");
										if (ans) ans.style.display = "";
									}
								});
							btn.classList.remove("is-expanded");
							if (labelEl) labelEl.textContent = moreLabel;
						} else if (hidden.length > 0) {
							hidden.forEach((item) =>
								item.classList.remove("faq-system__item--hidden")
							);
							btn.classList.add("is-expanded");
							if (labelEl) labelEl.textContent = lessLabel;
						}
					});
				});
		});
	};

	document.addEventListener("DOMContentLoaded", () => initFaqSystem());

	document.addEventListener("shopify:section:load", (e) => {
		const section = e.target.querySelector("[data-faq-system]");
		if (section) initFaqSystem(section);
	});

	// In case DOMContentLoaded already fired before this script ran
	if (document.readyState !== "loading") {
		initFaqSystem();
	}
})();
